import { createFileRoute, redirect } from "@tanstack/react-router";

import { IconButton, icons, MarkdownRenderer } from "@/ui";
import { faqs } from "./page";

const SingleFAQ = () => {
  const { id } = Route.useParams();

  const faq = id
    ? faqs.find((faq) => {
        return faq.id === parseInt(id);
      })
    : undefined;

  return (
    <div className="flex max-w-[500px] flex-col gap-4 text-content">
      <div className="flex flex-row items-start gap-2">
        <IconButton
          className="-ml-2"
          label="Back to FAQs"
          onClick={() => {
            window.history.back();
          }}
        >
          <icons.ChevronLeftIcon aria-hidden="true" className="size-6" />
        </IconButton>

        <h2 className="mt-2 text-xl font-semibold">{faq?.title}</h2>
      </div>

      <div className="whitespace-pre-wrap">
        <MarkdownRenderer>{faq?.body}</MarkdownRenderer>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_private/(faqs)/faqs/$id/")({
  beforeLoad: ({ params }) => {
    if (!params.id) {
      throw redirect({ to: "/faqs" });
    }
  },
  component: SingleFAQ,
});
